export const ROUTE_SETTING_MIN_OPACITY = 0;
export const ROUTE_SETTING_MAX_OPACITY = 0.8;
export const ROUTE_SETTING_OPACITY_STEP = 0.1;
